<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="" title="Dashboard" />
		<div v-if="user_role_id == 8">
			<div class="card">
				<div class="row">
					<div class="col-md-4 col-sm-6">
						<div class="card profile-box">
							<div class="card-body">
								<div class="media">
									<div class="media-body">
										<div class="greeting-user">
											<h4 class="f-w-600 mb-0">Welcome to <br>Speed Tech</h4>
											<p>Here whats happing in your account</p>
											<div class="whatsnew-btn">
												<a class="btn btn-outline-white" @click="scrollToSection">Create Service</a>
											</div>
										</div>
									</div>
									<div>
										<div class="clockbox">
											<svg id="clock" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 600">
												<g id="face">
													<circle class="circle" cx="300" cy="300" r="253.9"></circle>
													<path class="hour-marks" d="M300.5 94V61M506 300.5h32M300.5 506v33M94 300.5H60M411.3 107.8l7.9-13.8M493 190.2l13-7.4M492.1 411.4l16.5 9.5M411 492.3l8.9 15.3M189 492.3l-9.2 15.9M107.7 411L93 419.5M107.5 189.3l-17.1-9.9M188.1 108.2l-9-15.6"></path>
													<circle class="mid-circle" cx="300" cy="300" r="16.2"></circle>
												</g>
												<g id="hour">
													<path class="hour-hand" d="M300.5 298V142"></path>
													<circle class="sizing-box" cx="300" cy="300" r="253.9"></circle>
												</g>
												<g id="minute">
													<path class="minute-hand" d="M300.5 298V67"></path>
													<circle class="sizing-box" cx="300" cy="300" r="253.9"></circle>
												</g>
												<g id="second">
													<path class="second-hand" d="M300.5 350V55"></path>
													<circle class="sizing-box" cx="300" cy="300" r="253.9"></circle>
												</g>
											</svg>
										</div>
										<div class="badge f-10 p-0" id="txt"></div>
									</div>
								</div>
								<div class="cartoon">
									<img class="img-fluid" src="@/assets/images/dashboard/cartoon.svg" alt="vector women with leptop" />
								</div>
							</div>
						</div>
					</div>

					<div class="col-xl-8 col-md-8 box-col-6 col-ed-8">
						<div class="row">
							<div class="col-xl-12">
								<div class="card growth-wrap">
									<div class="card-header card-no-border growth-header">
										<div class="header-top">
											<h5>Product Sales Growth</h5>
											<div>
												<div class="dropdown">
													<select class="form-select" v-model="sales_growth_year" @change="fetchDashboard">
														<option v-for="year in yearOptions" :key="year" :value="year">{{ year }}</option>
													</select>
												</div>
											</div>
										</div>
									</div>
									<div class="card-body pt-0">
										<div class="growth-wrapper">
											<apexchart height="200" type="line" :options="apexDashboard.options6" :series="apexDashboard.series6"></apexchart>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-4">
						<div class="card mini-stats-wid">
							<div class="card-body">
								<div class="media mb-3">
									<div class="media-body">
										<p class="tild-head text-primary" style="font-weight: 800;">New Works</p>
									</div>

									<div class="float-end mm-cart-image text-primary" style="height: 52px; width: 50px;">
										<i class="icofont icofont-3x icofont icofont-chart-line-alt"></i>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
										<p class="mb-0 ">Today's</p>
									</div>

									<div class="align-self-center ">
										<span class="float-end me-3">
											<h6 class="font-weight-400">{{ today_new_works }}</h6>
										</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
										<p class="mb-0 ">This Week</p>
									</div>

									<div class="align-self-center ">
										<span class="float-end me-3">
											<h6 class="font-weight-400">{{ week_new_works }}</h6>
										</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
										<p class="mb-0 ">This Month</p>
									</div>

									<div class="align-self-center ">
										<span class="float-end me-3">
											<h6 class="font-weight-400">{{ month_new_works }}</h6>
										</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
										<p class="mb-0 ">Total</p>
									</div>

									<div class="align-self-center ">
										<span class="float-end me-3">
											<h6 class="font-weight-400">{{ new_works }}</h6>
										</span>
									</div>
								</div>

							</div>
						</div>
					</div>

					<div class="col-md-4">
						<div class="card mini-stats-wid">
							<div class="card-body">
								<div class="media mb-3">
									<div class="media-body">
										<p class="tild-head text-primary" style="font-weight: 800;">Other Works</p>
									</div>

									<div class="float-end mm-cart-image text-primary" style="height: 52px; width: 50px;">
										<i class="icofont icofont-3x icofont icofont-chart-line-alt"></i>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
										<p class="mb-0 ">Today's</p>
									</div>

									<div class="align-self-center ">
										<span class="float-end me-3">
											<h6 class="font-weight-400">{{ today_other_works }}</h6>
										</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
										<p class="mb-0 ">This Week</p>
									</div>

									<div class="align-self-center ">
										<span class="float-end me-3">
											<h6 class="font-weight-400">{{ week_other_works }}</h6>
										</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
										<p class="mb-0 ">This Month</p>
									</div>

									<div class="align-self-center ">
										<span class="float-end me-3">
											<h6 class="font-weight-400">{{ month_other_works }}</h6>
										</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
										<p class="mb-0 ">Total</p>
									</div>

									<div class="align-self-center ">
										<span class="float-end me-3">
											<h6 class="font-weight-400">{{ other_works }}</h6>
										</span>
									</div>
								</div>

							</div>
						</div>
					</div>

					<div class="col-md-4">
						<div class="card mini-stats-wid">
							<div class="card-body">
								<div class="media mb-3">
									<div class="media-body">
										<p class="tild-head text-primary" style="font-weight: 800;">Earnings(Rs.)</p>
									</div>

									<div class="float-end mm-cart-image text-primary" style="height: 52px; width: 50px;">
										<i class="icofont icofont-3x icofont icofont-chart-line-alt"></i>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
										<p class="mb-0 ">Today's</p>
									</div>

									<div class="align-self-center ">
										<span class="float-end me-3">
											<h6 class="font-weight-400">{{ today_earnings }}</h6>
										</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
										<p class="mb-0 ">This Week</p>
									</div>

									<div class="align-self-center ">
										<span class="float-end me-3">
											<h6 class="font-weight-400">{{ week_earnings }}</h6>
										</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
										<p class="mb-0 ">This Month</p>
									</div>

									<div class="align-self-center ">
										<span class="float-end me-3">
											<h6 class="font-weight-400">{{ month_earnings }}</h6>
										</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
										<p class="mb-0 ">Total</p>
									</div>

									<div class="align-self-center ">
										<span class="float-end me-3">
											<h6 class="font-weight-400">{{ earnings }}</h6>
										</span>
									</div>
								</div>

							</div>
						</div>
					</div>

				</div>

				<div class="row">
					<div class="col-md-4 col-12">
						<div class="card small-widget">
							<div class="card-body primary">
								<span class="text-primary">Top Performing Technician</span>
								<div class="d-flex align-items-end gap-1 mt-2">
									<h4 v-if="performing_technician">{{ performing_technician.name }}</h4>
									<h4 v-else>Loading...</h4>
									<vue-feather :class="iconClassUp" :type="trandingClassUp"></vue-feather>
								</div>
								<div class="bg-gradient">
									<svg class="stroke-icon svg-fill">
										<use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${svgIcon2}`"></use>
									</svg>
								</div>
							</div>
						</div>
					</div>

					<div class="col-md-4 col-12">
						<div class="card small-widget">
							<div class="card-body warning">
								<span class="text-primary">Most Incentive Earned</span>
								<div class="d-flex align-items-end gap-1 mt-2">
									<h4 v-if="incentive_technician">{{ incentive_technician.name }}</h4>
									<h4 v-else>Loading...</h4>
									<vue-feather :class="iconClassUp" :type="trandingClassUp"></vue-feather>
								</div>
								<div class="bg-gradient">
									<svg class="stroke-icon svg-fill">
										<use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${svgIcon4}`"></use>
									</svg>
								</div>
							</div>
						</div>
					</div>

					<div class="col-md-4 col-12">
						<div class="card small-widget">
							<div class="card-body success">
								<span class="text-primary">Most Sold Product</span>
								<div class="d-flex align-items-end gap-1 mt-2">
									<h4 v-if="sold_product">{{ sold_product.product_name }}</h4>
									<h4 v-else>Loading...</h4>
									<vue-feather :class="iconClassUp" :type="trandingClassUp"></vue-feather>
								</div>
								<div class="bg-gradient">
									<svg class="stroke-icon svg-fill">
										<use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${svgIcon1}`"></use>
									</svg>
								</div>
							</div>
						</div>
					</div>

				</div>

				<div class="row">

					<div class="col-xxl-12 box-col-12">
						<div class="card">
							<div class="card-header card-no-border">
								<div class="header-top">
									<div class="card-header-right-icon">
										<div class="dropdown">
											<select class="form-select" v-model="work_data_year" @change="fetchDashboard">
												<option v-for="year in yearOptions" :key="year" :value="year">{{ year }}</option>
											</select>
										</div>
									</div>
									
									<h5 class="m-0">Work Data</h5>

									<div class="card-header-right-icon">
										<div class="dropdown">
											<select class="form-select" v-model="service_type" @change="fetchDashboard">
												<option value="">All Type</option>
												<option :value="1">New</option>
												<option :value="2">Repair</option>
												<option :value="3">Replacement</option>
											</select>
										</div>
									</div>
										
								</div>
							</div>
								<!-- <div class="card-header card-no-border">
									<h5>Order Overview</h5>
									
								</div> -->
							<div class="card-body pt-0">
								<div class="row m-0 overall-card overview-card">
									<div class="col-xl-12 col-md-12 col-sm-12 p-0 box-col-7">
										<div class="chart-right">
											<div class="row">
												<div class="col-xl-12">
													<div class="card-body p-0 pt-4">
														<ul class="balance-data  pt-5">
															<li>
																<span class="circle" style="background-color: #93f1e7;"></span><span class="f-light ms-1">New</span>
															</li>
															<li>
																<span class="circle" style="background-color: #ffe333;"> </span><span class="f-light ms-1">Repair</span>
															</li>
															<li>
																<span class="circle" style="background-color: #ebeded;"></span><span class="f-light ms-1">Replacement</span>
															</li>
															
														</ul>
														<div class="current-sale-container order-container">
															<div class="overview-wrapper">
																<apexchart height="265" type="line" :options="ecomDashboard.options2" :series="ecomDashboard.series2"></apexchart>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
			<div class="card" id="deviceSearchSection">
				<div class="row">
					<div class="col-sm-12">
						<div class="card">
							<div class="card-body">

								<form  @submit.prevent="addWork" enctype="multipart/form-data">
									<div class="form theme-form">

										<div class="row">
											<div class="col-md-12 mb-4">
												<div class="form-check mt-4">
													<input class="form-check-input" type="checkbox" id="is_enquiry" v-model="is_enquiry"/>
													<label class="form-check-label fw-bold" for="is_enquiry">
														This job is an enquiry
													</label>
												</div>
												<span class="validate-error" v-if="errors.is_enquiry">
													{{ errors.is_enquiry[0] }}
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Product<span class="text-danger">*</span></label>
													<select class="form-select" v-model="product_id" v-bind:class="{ 'is-invalid': Boolean(errors.product_id) }">
														<option value="">Select</option>
														<option v-for="product in products" :value="product.id">{{ product.product_name }}</option>
													</select>
													<span class="validate-error" v-if="errors.product_id">
														{{ errors.product_id[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3 form-group" v-if="product_id">
												<label class="control-label">Work Type<span class="text-danger">*</span></label>
													<select class="form-select" v-model="work_type" v-bind:class="{ 'is-invalid': Boolean(errors.work_type) }">
														<option value="">Select</option>
														<option value="1">New</option>
														<option value="2">Repair</option>
														<option value="3">Replacement</option>
													</select>
												<span class="validate-error" v-if="errors.work_type">
													{{ errors.work_type[0] }}
												</span>
											</div>

											<div class="col-md-3" v-if="(product_id == 1) && (work_type == 2 || work_type == 3)">
												<div>
													<label class="control-label">Select IMEI<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Search IMEI or Vehicle No" v-model="device_imei" @input="handleImeiInput" @focus="showSuggestions = true" @blur="handleInputBlur" v-bind:class="{ 'is-invalid': Boolean(errors.device_id) }"/>
													<ul
														v-if="showSuggestions && devices.length" class="list-group position-absolute"
														style="width:93%; z-index: 9999; max-height: 200px; overflow-y: auto;"
														@scroll="handleScroll" ref="suggestionList"
													>
														<li v-for="device in devices" :key="device.imei" class="list-group-item list-group-item-action" @mousedown.prevent="setImei(device)">
															{{ device.vehicle_no + ' - ' + device.imei }}
														</li>
													</ul>
													<span class="validate-error" v-if="errors.device_id">
														{{ errors.device_id[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3" v-if="(product_id != 1) && (work_type == 2 || work_type == 3)">
												<div>
													<label class="control-label">Search Vehicle No<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Search Vehicle No or Mobile" v-model="vehicle_search" @input="handleVehicleSearchInput" @focus="showSuggestions = true" @blur="handleInputBlur" v-bind:class="{ 'is-invalid': Boolean(errors.device_id) }"/>
													<ul
														v-if="showSuggestions && devices.length" class="list-group position-absolute"
														style="width:93%; z-index: 9999; max-height: 200px; overflow-y: auto;"
														@scroll="handleScroll" ref="suggestionList"
													>
														<li v-for="device in devices" :key="device.imei" class="list-group-item list-group-item-action" @mousedown.prevent="setImei(device)">
															{{ device.vehicle_no + ' - ' + device.mobile }}
														</li>
													</ul>
													<span class="validate-error" v-if="errors.device_id">
														{{ errors.device_id[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3" v-if="(product_id == 1) && (work_type == 1)">
												<div class="mb-3">
													<label class="control-label">RC Image<span class="text-danger">*</span></label>
													<input ref="fileinput" type="file" @change="setFile($event)" accept="image/*" class="form-control image-class" v-bind:class="{ 'is-invalid': Boolean(errors.rc_image) }"/>
													<span class="validate-error" v-if="errors.rc_image">
														{{ errors.rc_image[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Select RTO<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Search RTO" v-model="rto_search" @input="handleRtoSearch" @focus="showRtoSuggestions = true" @blur="handleRtoInputBlur" v-bind:class="{ 'is-invalid': Boolean(errors.rto_id) }"/>
													<ul
														v-if="showRtoSuggestions && filteredRtoList.length" class="list-group position-absolute"
														style="width:93%; z-index: 9999; max-height: 200px; overflow-y: auto;"
														ref="rtoSuggestionList"
													>
														<li v-for="rto in filteredRtoList" :key="rto.id" class="list-group-item list-group-item-action" @mousedown.prevent="setRto(rto)">
															{{ rto.rto_code }} - {{ rto.rto_name }}
														</li>
													</ul>
													<span class="validate-error" v-if="errors.rto_id">
														{{ errors.rto_id[0] }}
													</span>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Customer Name<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Enter Customer Name" v-model="customer_name" v-bind:class="{ 'is-invalid': Boolean(errors.customer_name) }"/>
													<span class="validate-error" v-if="errors.customer_name">
														{{ errors.customer_name[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Mobile No.<span class="text-danger">*</span></label>
												<input class="form-control" type="number" placeholder="Enter Customer Mobile" v-model="mobile" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }" maxlength="10" minlength="10" @input="restrictMobileInput"/>
												<span class="validate-error" v-if="errors.mobile">
													{{ errors.mobile[0] }}
												</span>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Vehicle Type.<span class="text-danger">*</span></label>
													<select class="form-select" v-model="vehicle_type" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_type) }">
														<option value="">Select Vehicle Type</option>
														<option v-for="type in vehicle_types" :value="type.id">{{ type.name }}</option>
													</select>
												<span class="validate-error" v-if="errors.vehicle_type">
													{{ errors.vehicle_type[0] }}
												</span>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Vehicle No.<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="Enter Vehicle Number" v-model="vehicle_no" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_no) }"/>
												<span class="validate-error" v-if="errors.vehicle_no">
													{{ errors.vehicle_no[0] }}
												</span>
											</div>

											<div class="col-md-12">
												<div class="mb-3">
													<label class="control-label">Location<span class="text-danger">*</span></label>

													<GMapAutocomplete 
														@place_changed="setPlace" class="form-control" 
														placeholder="Search here to pick the required latitude and longitude..."
														:value="job.location"
														v-bind:class="{ 'is-invalid': Boolean(errors.location) }">
													</GMapAutocomplete>

													<GMapMap v-if="job.location"
														:center="center"
														:zoom="18"
														map-style-id="roadmap"
														:options="mapOptions"
														style="width: 100%; height: 30vmin"
														ref="mapRef"
														@click="handleMapClick">
															<GMapMarker 
																:position="marker.position"
																:clickable="true"
																:draggable="true"
																@drag="handleMarkerDrag"
																@click="panToMarker"
															/>
													</GMapMap > 

													<!-- <input class="form-control" type="text" placeholder="Search the location here..." v-model="location"/> -->
													<span class="validate-error" v-if="errors.location">
														{{ errors.location[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-6">
												<div class="mb-3">
													<label class="control-label">Latitude<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="" v-model="marker.position.lat" disabled v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"/>
													<span class="validate-error" v-if="errors.latitude">
														{{ errors.latitude[0] }}
													</span>
												</div>
											</div>
											<div class="col-md-6">
												<div class="mb-3">
													<label class="control-label">Longitude<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="" v-model="marker.position.lng" disabled v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }"/>
													<span class="validate-error" v-if="errors.longitude">
														{{ errors.longitude[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Technician<span class="text-danger">*</span></label>
													<select class="form-select" v-model="technician_id" v-bind:class="{ 'is-invalid': Boolean(errors.technician_id) }">
														<option value="">Select Technician</option>
														<option v-for="technician in technicians" :value="technician.id">{{ technician.name }}</option>
													</select>
													<span class="validate-error" v-if="errors.technician_id">
														{{ errors.technician_id[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Amount<span class="text-danger">*</span></label>
													<input class="form-control" type="number" placeholder="" v-model="amount" v-bind:class="{ 'is-invalid': Boolean(errors.amount) }"/>
													<span class="validate-error" v-if="errors.amount">
														{{ errors.amount[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Date<span class="text-danger">*</span></label>
													<input class="form-control" type="date" placeholder="" v-model="date" v-bind:class="{ 'is-invalid': Boolean(errors.date) }"/>
													<span class="validate-error" v-if="errors.date">
														{{ errors.date[0] }}
													</span>
												</div>
											</div>

										</div>
										<div class="row mt-3">
											<div class="col-sm-12">
												<button class="btn btn-success me-2 float-end" type="submit" :disabled="isSubmitting">
													<span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
													{{ isSubmitting ? 'Saving...' : 'Save' }}
												</button>
											</div>
										</div>
		
									</div>
								</form>
							</div>

							<!-- Debug: {{ device_imei }} | {{ vehicle_search }} | {{ user_role_id }} | data: {{ device_work_logs?.length }} -->
							<div class="card-body" v-if="(device_imei && device_imei.trim() !== '') || (vehicle_search && vehicle_search.trim() !== '') || (device_work_logs && device_work_logs.length > 0)">
								<div class="row">
									<div class="col-lg-12 col-md-12 mt-3">
										<div header-class="bg-transparent border-light" class="border border-light">
											<h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
												Work Logs
											</h4>

											<div class="col-md-12 project-list filter-sort">
												<div class="row">
													<div class="col-md-8 d-flex mt-2">
														<label class="d-flex listing-length ms-1"><span>Show</span>
															<select class="form-select" v-model="listing_length" @change="fetchDeviceWorkLogs()">
																<option value="5">5</option>
																<option value="10">10</option>
																<option value="20">20</option>
															</select>
															<span>entries</span>
														</label>
													</div>
												</div>
											</div>

											<div class="table-responsive product-table">
												<table class="display" id="basic-1">
													<thead>
														<tr align="center">
															<th>Sl.No</th>
															<th>Customer</th>
															<th>Technician</th>
															<th>Location</th>
															<th>Date</th>
															<th>Product</th>
															<th>Type</th>
															<th>Amount</th>
															<th>Status</th>
															<th>Remarks</th>
														</tr>
													</thead>
													<tbody v-if="device_work_logs && device_work_logs.length > 0">
														<tr align="center" v-for="(work, index) in device_work_logs" :key="index">
															<td>{{ (from || 1) - 1 + index + 1 }}</td>
															<td>{{ work.customer_name }}</td>
															<td>{{ work.technician?.name || 'N/A' }}</td>
															<td>{{ work.location }}</td>
															<td>{{ proxy.$filters.convertDate(work.date) }}</td>
															<td>{{ work.product?.product_name || 'N/A' }}</td>
															<td>
																<span v-if="work.service_type == 1">New</span>
																<span v-else-if="work.service_type == 2">Repair</span>
																<span v-else>Replacement</span>
															</td>
															<td>Rs. {{ work.total_amount }}</td>
															<td>
																<span class="badge rounded-pill bg-warning" v-if="work.job_status === 1">Pending</span>
																<span class="badge rounded-pill bg-primary" v-else-if="work.job_status === 2">Ongoing</span>
																<span class="badge rounded-pill bg-success" v-else-if="work.job_status === 3">Completed</span>
																<span class="badge rounded-pill bg-danger" v-else-if="work.job_status === 4">Requested</span>
																<span class="badge rounded-pill bg-danger" v-else-if="work.job_status === 5">Cancelled</span>
																<span class="badge rounded-pill bg-secondary" v-else-if="work.job_status === 6">Reassigned</span>
																<span class="badge rounded-pill bg-warning" v-else-if="work.job_status === 7">Pending</span>
															</td>
															<td>{{ work.remarks || 'N/A' }}</td>
														</tr>
													</tbody>
													<tbody v-else>
														<tr>
															<td colspan="10" class="text-center">No work logs found</td>
														</tr>
													</tbody>
												</table>
											</div>

											<!----pagination starts --->
											<nav aria-label="Page navigation" class="mt-2">
												<ul class="pagination">
													<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
													<a class="page-link" href="#" @click.prevent="fetchDeviceWorkLogs(page.url)" tabindex="-1">
														<span v-if="index === 0">Prev</span>
														<span v-else-if="index === pagination.length - 1">Next</span>
														<span v-else v-html="page.label"></span>
													</a>
													</li>
												</ul>
											</nav>
											<!----pagination ends --->

										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-else>
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<form  @submit.prevent="addWork" enctype="multipart/form-data">
								<div class="form theme-form">

									<div class="row">
										<div class="col-md-12 mb-4">
											<div class="form-check mt-4">
												<input class="form-check-input" type="checkbox" id="is_enquiry" v-model="is_enquiry"/>
												<label class="form-check-label fw-bold" for="is_enquiry">
													This job is an enquiry
												</label>
											</div>
											<span class="validate-error" v-if="errors.is_enquiry">
												{{ errors.is_enquiry[0] }}
											</span>
										</div>
									</div>
									<div class="row">
										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Product<span class="text-danger">*</span></label>
												<select class="form-select" v-model="product_id" v-bind:class="{ 'is-invalid': Boolean(errors.product_id) }">
													<option value="">Select</option>
													<option v-for="product in products" :value="product.id">{{ product.product_name }}</option>
												</select>
												<span class="validate-error" v-if="errors.product_id">
													{{ errors.product_id[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-3 form-group" v-if="product_id">
											<label class="control-label">Work Type<span class="text-danger">*</span></label>
												<select class="form-select" v-model="work_type" v-bind:class="{ 'is-invalid': Boolean(errors.work_type) }">
													<option value="">Select</option>
													<option value="1">New</option>
													<option value="2">Repair</option>
													<option value="3">Replacement</option>
												</select>
											<span class="validate-error" v-if="errors.work_type">
												{{ errors.work_type[0] }}
											</span>
										</div>

										<div class="col-md-3" v-if="(product_id == 1) && (work_type == 2 || work_type == 3)">
											<div>
												<label class="control-label">Select IMEI<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="Search IMEI or Vehicle No" v-model="device_imei" @input="handleImeiInput" @focus="showSuggestions = true" @blur="handleInputBlur" v-bind:class="{ 'is-invalid': Boolean(errors.device_id) }"/>
												<ul
													v-if="showSuggestions && devices.length" class="list-group position-absolute"
													style="width:93%; z-index: 9999; max-height: 200px; overflow-y: auto;"
													@scroll="handleScroll" ref="suggestionList"
												>
													<li v-for="device in devices" :key="device.imei" class="list-group-item list-group-item-action" @mousedown.prevent="setImei(device)">
														{{ device.vehicle_no + ' - ' + device.imei }}
													</li>
												</ul>
												<span class="validate-error" v-if="errors.device_id">
													{{ errors.device_id[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-3" v-if="(product_id != 1) && (work_type == 2 || work_type == 3)">
											<div>
												<label class="control-label">Search Vehicle No<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="Search Vehicle No or Mobile" v-model="vehicle_search" @input="handleVehicleSearchInput" @focus="showSuggestions = true" @blur="handleInputBlur" v-bind:class="{ 'is-invalid': Boolean(errors.device_id) }"/>
												<ul
													v-if="showSuggestions && devices.length" class="list-group position-absolute"
													style="width:93%; z-index: 9999; max-height: 200px; overflow-y: auto;"
													@scroll="handleScroll" ref="suggestionList"
												>
													<li v-for="device in devices" :key="device.imei" class="list-group-item list-group-item-action" @mousedown.prevent="setImei(device)">
														{{ device.vehicle_no + ' - ' + device.mobile }}
													</li>
												</ul>
												<span class="validate-error" v-if="errors.device_id">
													{{ errors.device_id[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-3" v-if="(product_id == 1) && (work_type == 1)">
											<div class="mb-3">
												<label class="control-label">RC Image<span class="text-danger">*</span></label>
												<input ref="fileinput" type="file" @change="setFile($event)" accept="image/*" class="form-control image-class" v-bind:class="{ 'is-invalid': Boolean(errors.rc_image) }"/>
												<span class="validate-error" v-if="errors.rc_image">
													{{ errors.rc_image[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Select RTO<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="Search RTO" v-model="rto_search" @input="handleRtoSearch" @focus="showRtoSuggestions = true" @blur="handleRtoInputBlur" v-bind:class="{ 'is-invalid': Boolean(errors.rto_id) }"/>
												<ul
													v-if="showRtoSuggestions && filteredRtoList.length" class="list-group position-absolute"
													style="width:93%; z-index: 9999; max-height: 200px; overflow-y: auto;"
													ref="rtoSuggestionList"
												>
													<li v-for="rto in filteredRtoList" :key="rto.id" class="list-group-item list-group-item-action" @mousedown.prevent="setRto(rto)">
														{{ rto.rto_code }} - {{ rto.rto_name }}
													</li>
												</ul>
												<span class="validate-error" v-if="errors.rto_id">
													{{ errors.rto_id[0] }}
												</span>
											</div>
										</div>

									</div>

									<div class="row">
										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Customer Name<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="Enter Customer Name" v-model="customer_name" v-bind:class="{ 'is-invalid': Boolean(errors.customer_name) }"/>
												<span class="validate-error" v-if="errors.customer_name">
													{{ errors.customer_name[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-3 form-group">
											<label class="control-label">Mobile No.<span class="text-danger">*</span></label>
											<input class="form-control" type="number" placeholder="Enter Customer Mobile" v-model="mobile" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }" maxlength="10" minlength="10" @input="restrictMobileInput"/>
											<span class="validate-error" v-if="errors.mobile">
												{{ errors.mobile[0] }}
											</span>
										</div>

										<div class="col-md-3 form-group">
											<label class="control-label">Vehicle Type.<span class="text-danger">*</span></label>
												<select class="form-select" v-model="vehicle_type" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_type) }">
													<option value="">Select Vehicle Type</option>
													<option v-for="type in vehicle_types" :value="type.id">{{ type.name }}</option>
												</select>
											<span class="validate-error" v-if="errors.vehicle_type">
												{{ errors.vehicle_type[0] }}
											</span>
										</div>

										<div class="col-md-3 form-group">
											<label class="control-label">Vehicle No.<span class="text-danger">*</span></label>
											<input class="form-control" type="text" placeholder="Enter Vehicle Number" v-model="vehicle_no" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_no) }"/>
											<span class="validate-error" v-if="errors.vehicle_no">
												{{ errors.vehicle_no[0] }}
											</span>
										</div>

										<div class="col-md-12">
											<div class="mb-3">
												<label class="control-label">Location<span class="text-danger">*</span></label>

												<GMapAutocomplete 
													@place_changed="setPlace" class="form-control" 
													placeholder="Search here to pick the required latitude and longitude..."
													:value="job.location"
													v-bind:class="{ 'is-invalid': Boolean(errors.location) }">
												</GMapAutocomplete>

												<GMapMap v-if="job.location"
													:center="center"
													:zoom="18"
													map-style-id="roadmap"
													:options="mapOptions"
													style="width: 100%; height: 30vmin"
													ref="mapRef"
													@click="handleMapClick">
														<GMapMarker 
															:position="marker.position"
															:clickable="true"
															:draggable="true"
															@drag="handleMarkerDrag"
															@click="panToMarker"
														/>
												</GMapMap > 

												<!-- <input class="form-control" type="text" placeholder="Search the location here..." v-model="location"/> -->
												<span class="validate-error" v-if="errors.location">
													{{ errors.location[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-6">
											<div class="mb-3">
												<label class="control-label">Latitude<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="marker.position.lat" disabled v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"/>
												<span class="validate-error" v-if="errors.latitude">
													{{ errors.latitude[0] }}
												</span>
											</div>
										</div>
										<div class="col-md-6">
											<div class="mb-3">
												<label class="control-label">Longitude<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="marker.position.lng" disabled v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }"/>
												<span class="validate-error" v-if="errors.longitude">
													{{ errors.longitude[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Technician<span class="text-danger">*</span></label>
												<select class="form-select" v-model="technician_id" v-bind:class="{ 'is-invalid': Boolean(errors.technician_id) }">
													<option value="">Select Technician</option>
													<option v-for="technician in technicians" :value="technician.id">{{ technician.name }}</option>
												</select>
												<span class="validate-error" v-if="errors.technician_id">
													{{ errors.technician_id[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Amount<span class="text-danger">*</span></label>
												<input class="form-control" type="number" placeholder="" v-model="amount" v-bind:class="{ 'is-invalid': Boolean(errors.amount) }"/>
												<span class="validate-error" v-if="errors.amount">
													{{ errors.amount[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Date<span class="text-danger">*</span></label>
												<input class="form-control" type="date" placeholder="" v-model="date" v-bind:class="{ 'is-invalid': Boolean(errors.date) }"/>
												<span class="validate-error" v-if="errors.date">
													{{ errors.date[0] }}
												</span>
											</div>
										</div>

									</div>
									<div class="row mt-3">
										<div class="col-sm-12">
											<button class="btn btn-success me-2 float-end" type="submit" :disabled="isSubmitting">
												<span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
												{{ isSubmitting ? 'Saving...' : 'Save' }}
											</button>
										</div>
									</div>
	
								</div>
							</form>
						</div>

						<!-- Debug: {{ device_imei }} | {{ vehicle_search }} | {{ user_role_id }} | data: {{ device_work_logs?.length }} -->
						<div class="card-body" v-if="(device_imei && device_imei.trim() !== '') || (vehicle_search && vehicle_search.trim() !== '') || (device_work_logs && device_work_logs.length > 0)">
							<div class="row">
								<div class="col-lg-12 col-md-12 mt-3">
									<div header-class="bg-transparent border-light" class="border border-light">
										<h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
											Work Logs
										</h4>

										<div class="col-md-12 project-list filter-sort">
											<div class="row">
												<div class="col-md-8 d-flex mt-2">
													<label class="d-flex listing-length ms-1"><span>Show</span>
														<select class="form-select" v-model="listing_length" @change="fetchDeviceWorkLogs()">
															<option value="5">5</option>
															<option value="10">10</option>
															<option value="20">20</option>
														</select>
														<span>entries</span>
													</label>
												</div>
											</div>
										</div>

										<div class="table-responsive product-table">
											<table class="display" id="basic-2">
												<thead>
													<tr align="center">
														<th>Sl.No</th>
														<th>Customer</th>
														<th>Technician</th>
														<th>Location</th>
														<th>Date</th>
														<th>Product</th>
														<th>Type</th>
														<th>Amount</th>
														<th>Status</th>
														<th>Remarks</th>
													</tr>
												</thead>
												<tbody v-if="device_work_logs && device_work_logs.length > 0">
													<tr align="center" v-for="(work, index) in device_work_logs" :key="index">
														<td>{{ (from || 1) - 1 + index + 1 }}</td>
														<td>{{ work.customer_name }}</td>
														<td>{{ work.technician?.name || 'N/A' }}</td>
														<td>{{ work.location }}</td>
														<td>{{ proxy.$filters.convertDate(work.date) }}</td>
														<td>{{ work.product?.product_name || 'N/A' }}</td>
														<td>
															<span v-if="work.service_type == 1">New</span>
															<span v-else-if="work.service_type == 2">Repair</span>
															<span v-else>Replacement</span>
														</td>
														<td>Rs. {{ work.total_amount }}</td>
														<td>
															<span class="badge rounded-pill bg-warning" v-if="work.job_status === 1">Pending</span>
															<span class="badge rounded-pill bg-primary" v-else-if="work.job_status === 2">Ongoing</span>
															<span class="badge rounded-pill bg-success" v-else-if="work.job_status === 3">Completed</span>
															<span class="badge rounded-pill bg-danger" v-else-if="work.job_status === 4">Requested</span>
															<span class="badge rounded-pill bg-danger" v-else-if="work.job_status === 5">Cancelled</span>
															<span class="badge rounded-pill bg-secondary" v-else-if="work.job_status === 6">Reassigned</span>
															<span class="badge rounded-pill bg-warning" v-else-if="work.job_status === 7">Pending</span>
														</td>
														<td>{{ work.remarks || 'N/A' }}</td>
													</tr>
												</tbody>
												<tbody v-else>
													<tr>
														<td colspan="10" class="text-center">No work logs found</td>
													</tr>
												</tbody>
											</table>
										</div>

										<!----pagination starts --->
										<nav aria-label="Page navigation" class="mt-2">
											<ul class="pagination">
												<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
												<a class="page-link" href="#" @click.prevent="fetchDeviceWorkLogs(page.url)" tabindex="-1">
													<span v-if="index === 0">Prev</span>
													<span v-else-if="index === pagination.length - 1">Next</span>
													<span v-else v-html="page.label"></span>
												</a>
												</li>
											</ul>
										</nav>
										<!----pagination ends --->

									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script setup>
	import { ref, reactive, onUnmounted, computed, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue';
	import '@/assets/css/custom.css';
	import { routes } from '@/constants/routes';
	import Swal from '@/utils/swal';
	import { get, post } from '@/utils/api';
	import { useRouter } from 'vue-router';
	import { debounce } from 'lodash';
	const { proxy } = getCurrentInstance();
	
	const router = useRouter();
	const currentYear = new Date().getFullYear();

	// Icons
	const svgIcon1 = ref("new-order");
	const svgIcon2 = ref("customers");
	const svgIcon3 = ref("sale");
	const svgIcon4 = ref("profit");
	const iconClassUp = ref("font-success ms-2");
	const trandingClassUp = ("trending-up");

	// Time & Greeting
	const greeting = ref("");
	const time = ref("");
	let interval = null;
	const service_type = ref("");
	const work_data_year = ref(currentYear);
	const sales_growth_year = ref(currentYear);
	const today_new_works = ref("");
	const week_new_works = ref("");
	const month_new_works = ref("");
	const new_works = ref("");

	const today_other_works = ref("");
	const week_other_works = ref("");
	const month_other_works = ref("");
	const other_works = ref("");

	const today_earnings = ref("");
	const week_earnings = ref("");
	const month_earnings = ref("");
	const earnings = ref("");

	// Arrays
	const product_sale_growth = ref([]); 
	const new_work_data = ref([]); 
	const repair_work_data = ref([]); 
	const replacement_work_data = ref([]); 

	const performing_technician = ref("");
	const incentive_technician = ref("");
	const sold_product = ref("");
	// Errors & Token
	const errors = reactive({});
	const user_role_id = ref("");

	const yearOptions = computed(() => {
	const years = [];
	for (let i = 0; i < 5; i++) {  // Show last 5 years
		years.push(currentYear - i);
	}
	return years;
	});

	// Computed property for filtered RTO list
	const filteredRtoList = computed(() => {
		if (!rto_search.value || rto_search.value.trim() === '') {
			return rto_list.value;
		}
		const searchTerm = rto_search.value.toLowerCase();
		return rto_list.value.filter(rto => 
			rto.rto_code.toLowerCase().includes(searchTerm) || 
			rto.rto_name.toLowerCase().includes(searchTerm)
		);
	});


	// Apex Chart Options
	const ecomDashboard = reactive({
	options2: {
		chart: {
		height: 300,
		type: 'line',
		stacked: false,
		toolbar: { show: false },
		dropShadow: {
			enabled: true,
			top: 2,
			left: 0,
			blur: 4,
			color: '#000',
			opacity: 0.08
		}
		},
		stroke: {
		width: [2, 2, 2, 2],
		curve: 'smooth'
		},
		grid: {
		show: true,
		borderColor: 'var(--chart-border)',
		strokeDashArray: 0,
		position: 'back',
		xaxis: {
			lines: { show: true }
		},
		padding: { top: 0, right: 0, bottom: 0, left: 0 },
		},
		plotOptions: {
		bar: { columnWidth: '50%' }
		},
		colors: ["#93f1e7", "#ffe333", "#ebeded"],
		fill: {
		type: 'gradient',
		gradient: {
			shade: 'light',
			type: "vertical",
			opacityFrom: 0.4,
			opacityTo: 0,
			stops: [0, 100]
		}
		},
		labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	},

	series2: [
		{
		name: 'New',
		type: 'area',
		data: new_work_data ?? []
		},
		{
		name: 'Repair',
		type: 'area',
		data: repair_work_data ?? []
		},
		{
		name: 'Replacement',
		type: 'area',
		data: replacement_work_data ?? []
		},
	],
	});

	const apexDashboard  = reactive({
		options6: {
			chart: {
				height: 135,
				type: 'line',
				toolbar: {
					show: false
				},
				dropShadow: {
					enabled: true,
					enabledOnSeries: undefined,
					top: 5,
					left: 0,
					blur: 4,
					color: '#7366ff',
					opacity: 0.22
				},
			},
			grid: {
				yaxis: {
					lines: {
						show: false
					}
				},
			},
			colors: ["#5527FF"],
			stroke: {
				width: 3,
				curve: 'smooth'
			},
			xaxis: {
				type: 'category',
				categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan'],
				tickAmount: 10,
				labels: {
					style: {
						fontFamily: 'Rubik, sans-serif',
					},
				},
				axisTicks: {
					show: false
				},
				axisBorder: {
					show: false
				},
				tooltip: {
					enabled: false,
				},
			},
			fill: {
				type: 'gradient',
				gradient: {
					shade: 'dark',
					gradientToColors: ['#5527FF'],
					shadeIntensity: 1,
					type: 'horizontal',
					opacityFrom: 1,
					opacityTo: 1,
					colorStops: [{
							offset: 0,
							color: "#5527FF",
							opacity: 1
						},
						{
							offset: 100,
							color: "#E069AE",
							opacity: 1
						},
					]
				},
			},
			yaxis: {
				min: -10,
				max: 40,
				labels: {
					show: false
				}
			},
			responsive: [{
					breakpoint: 992,
					options: {
						chart: {
							height: 150,
						}
					},
				},
				{
					breakpoint: 768,
					options: {
						chart: {
							height: 200,
						}
					},
				}
			]
		},
		series6: [{
			name: 'Growth',
			data: product_sale_growth ?? []
		}],
	});

	// Example for setting greeting/time logic on mount
	onMounted(() => {
		updateTime();
		runClock();
		interval = setInterval(() => {
			updateTime();
			runClock();
		}, 1000);
		fetchDashboard();

		fetchProducts();
		fetchTechnicians();
		fetchVehicleTypes();
		fetchRTOList();

		// Add click outside listener
		document.addEventListener('click', handleClickOutside);
	});

	onUnmounted(() => {
		if (interval.value) clearInterval(interval.value);
		// Remove click outside listener
		document.removeEventListener('click', handleClickOutside);
	});

	// Function to update time and greeting
	const updateTime = () => {
	const now = new Date();
	time.value = now.toLocaleTimeString();

	const hours = now.getHours();
	if (hours < 12) greeting.value = "Good Morning";
	else if (hours < 18) greeting.value = "Good Afternoon";
	else greeting.value = "Good Evening";
	};

	const runClock = () => {
	const HOURHAND = document.querySelector("#hour");
	const MINUTEHAND = document.querySelector("#minute");
	const SECONDHAND = document.querySelector("#second");

	const date = new Date();
	let hr = date.getHours();
	let min = date.getMinutes();
	let sec = date.getSeconds();
	const ampm = hr >= 12 ? "PM" : "AM";

	hr = hr % 12;
	hr = hr ? hr : 12;

	const hrPosition = (hr * 360) / 12 + (min * 360) / (12 * 60);
	const minPosition = (min * 360) / 60 + (sec * 360) / (60 * 60);
	const secPosition = (sec * 360) / 60;

	if (HOURHAND) HOURHAND.style.transform = `rotate(${hrPosition}deg)`;
	if (MINUTEHAND) MINUTEHAND.style.transform = `rotate(${minPosition}deg)`;
	if (SECONDHAND) SECONDHAND.style.transform = `rotate(${secPosition}deg)`;

	// Digital Clock
	const formattedMinutes = min < 10 ? "0" + min : min;
	const formattedSeconds = sec < 10 ? "0" + sec : sec;
	const txt = document.getElementById("txt");
	if (txt) txt.innerHTML = `${hr}:${formattedMinutes}:${formattedSeconds} ${ampm}`;
	};

	// Get today's date in local timezone (IST)
	const now = new Date();
	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	// Format date as YYYY-MM-DD for date input using local timezone
	const year = today.getFullYear();
	const month = String(today.getMonth() + 1).padStart(2, '0');
	const day = String(today.getDate()).padStart(2, '0');
	const todayFormatted = `${year}-${month}-${day}`;
	const date = ref(todayFormatted);

	const min = date.value;
	const max = todayFormatted;

	const fetchDashboard = () => {
	
	const params = {
		sales_growth_year: sales_growth_year.value,
		work_data_year: work_data_year.value,
		service_type: service_type.value
	};

	get(routes.Dashboard, { params }, false)
		.then((response) => {
		if (response.status === 200) {
			console.log(response.data.data);
			today_new_works.value = response.data.data.today_new_works;
			week_new_works.value = response.data.data.week_new_works;
			month_new_works.value = response.data.data.month_new_works;
			new_works.value = response.data.data.new_works;

			today_other_works.value = response.data.data.today_other_works;
			week_other_works.value = response.data.data.week_other_works;
			month_other_works.value = response.data.data.month_other_works;
			other_works.value = response.data.data.other_works;

			today_earnings.value = response.data.data.today_earnings;
			week_earnings.value = response.data.data.week_earnings;
			month_earnings.value = response.data.data.month_earnings;
			earnings.value = response.data.data.earnings;

			product_sale_growth.value = response.data.data.product_sale_growth ?? [];
			new_work_data.value = response.data.data.work_data.new ?? [];
			repair_work_data.value = response.data.data.work_data.repair ?? [];
			replacement_work_data.value = response.data.data.work_data.replacement ?? [];

			performing_technician.value = response.data.data.performing_technician;
			incentive_technician.value = response.data.data.incentive_technician;
			sold_product.value = response.data.data.sold_product;
			
			user_role_id.value = response.data.data.role_id;
			console.log(user_role_id.value);
					
		} else {
			Swal.fire('', response.data.message || 'Error fetching data', 'error');
		}
		})
		.catch((error) => {
		if (error.response?.status === 422) {
			Swal.fire(
			'',
			error.response.data.message?.work_data_year?.[0] 
			|| error.response.data.message?.sales_growth_year?.[0] 
			|| error.response.data.message?.service_type?.[0] 
			|| 'Validation error',
			'error'
			);      
			
		} else if (error.response?.status === 500) {
			Swal.fire('', error.response.statusText || 'Server error', 'error');
		} else if (error.response?.status === 401) {
			Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
			router.push({ name: 'login' });
		} else {
			Swal.fire('', error.response.data?.message || 'Error occured', 'error');
		}
		});

	};


	onBeforeUnmount(() => {
	if (interval) clearInterval(interval);
	});


	//Work Management

	const fetchDevicesDebounced = debounce(() => fetchDevices(), 300);
	const fetchAllDevicesDebounced = debounce(() => fetchAllDevicesForSearch(), 300);
	const products = ref([]);
	const product_id = ref("");
	const mobile = ref("");
	const customer_name = ref("");
	const work_type = ref("");
	const technician_id = ref("");
	const vehicle_no = ref("");
	const location = ref("");
	const latitude = ref("");
	const longitude = ref("");
	const technicians = ref({});
	const amount = ref("");
	const is_enquiry = ref(false); 
	const rc_image = ref(null);
	const device_imei = ref("");
	const devices = ref([]);
	const showSuggestions = ref(false);
	const device_id = ref("");
	const vehicle_types = ref([]);
	const vehicle_type = ref("");
	const suggestionList = ref(null);
 	const device_work_logs = ref([]);
	const listing_length = ref(10);
	const from = ref(null);
	const to = ref(null);
	const total = ref(null);
	const pagination = ref({});
	const mapRef = ref(null);
	const vehicle_search = ref("");
	const isSubmitting = ref(false);
	
	// RTO dropdown variables
	const rto_list = ref([]);
	const rto_id = ref("");
	const rto_search = ref("");
	const showRtoSuggestions = ref(false);
	const rtoSuggestionList = ref(null);

	const marker = ref({
		position: { lat: null, lng: null }
	});

	const center = ref({
		lat: null,
		lng: null
	});

	const current_place = ref(null);

	const mapOptions = {
		disableDefaultUI: true,
	};

	const job = ref({
		location: '',
		latitude: null,
		longitude: null
	});

	const geolocate = () => {
		navigator.geolocation.getCurrentPosition((position) => {
			marker.value.position = {
			lat: position.coords.latitude,
			lng: position.coords.longitude,
			};
			panToMarker();
		});
	};

	const panToMarker = () => {
		mapRef.value?.panTo(marker.value.position);
	};

	const handleMarkerDrag = (e) => {
		marker.value.position = {
			lat: e.latLng.lat(),
			lng: e.latLng.lng(),
		};
		// Update job coordinates when marker is dragged
		job.value.latitude = e.latLng.lat();
		job.value.longitude = e.latLng.lng();
	};

	const handleMapClick = (e) => {
		marker.value.position = {
			lat: e.latLng.lat(),
			lng: e.latLng.lng(),
		};
		// Update job coordinates when map is clicked
		job.value.latitude = e.latLng.lat();
		job.value.longitude = e.latLng.lng();
		console.log(e);
	};

	const setPlace = (place) => {
		current_place.value = place;
		if (current_place.value) {
			const lat = current_place.value.geometry.location.lat();
			const lng = current_place.value.geometry.location.lng();
			const markerPos = { lat, lng };

			center.value = markerPos;
			marker.value.position = markerPos;

			job.value.location = place.formatted_address;
			job.value.latitude = lat;
			job.value.longitude = lng;
		}
	};


	const handleScroll = () => {
		// Note: Pagination removed as it's not supported by the current API
		// If pagination is needed, it can be added to fetchAllDevicesForSearch
	};

	const scrollToSection = () => {
		const section = document.getElementById('deviceSearchSection');
		if (section) {
			const topOffset = section.getBoundingClientRect().top + window.scrollY - 100; // Calculate the exact position with offset
			window.scrollTo({
				top: topOffset,
				behavior: 'smooth',
			});
		}
	};

	const fetchProducts = () => {

		get(routes.AllProducts, {}, false)
			.then((response) => {
				if (response.status === 200) {
					products.value = response.data.data;
					// console.log(response.data.data);
				} else {
					Swal.fire('Error', response.data.message || 'Error fetching products', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const fetchTechnicians = () => {

		get(routes.AllTechnicians, {}, false)
			.then((response) => {
				if (response.status === 200) {
					// console.log(response.data.data);
					technicians.value = response.data.data;
				} else {
					Swal.fire('Error', response.data.message || 'Error fetching technicians', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const fetchAllDevicesForSearch = () => {
		// Only use for GPS products (product_id == 1)
		const searchTerm = device_imei.value;

		// Don't fetch if no keyword is provided
		if (!searchTerm || searchTerm.trim() === '') {
			devices.value = [];
			showSuggestions.value = false;
			return;
		}

		const params = {
			keyword: searchTerm,
		};

		get(routes.AllDevices, { params }, false)
			.then((response) => {
				if (response.status === 200) {
					// console.log('All Devices Search Results:', response.data.data);
					// Store all devices with imei and vehicle_no
					devices.value = response.data.data || [];
					// Show suggestions if we have devices and input is focused
					if (devices.value.length > 0) {
						showSuggestions.value = true;
					}
				} else {
					Swal.fire('Error', response.data.message || 'Error fetching devices', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const fetchDevices = () => {
		
		// Determine which search term to use based on product_id
		let searchTerm = '';
		if (product_id.value == 1 || product_id.value == '1') {
			searchTerm = device_imei.value;
		} else {
			searchTerm = vehicle_search.value;
		}

		// Don't fetch if no keyword is provided
		if (!searchTerm || searchTerm.trim() === '') {
			devices.value = [];
			showSuggestions.value = false;
			return;
		}

		const params = {
			keyword: searchTerm,
		};

		get(routes.searchJobData, { params }, false)
			.then((response) => {
				if (response.status === 200) {

					// const fetched = response.data.data;
					// console.log(response.data.data);
					// Filter out devices with null IMEI only for product_id = 1
					if (product_id.value == 1 || product_id.value == '1') {
						devices.value = (response.data.data || []).filter(device => device.imei !== null && device.imei !== '');
					} else {
						devices.value = response.data.data || [];
					}
					// Show suggestions if we have devices and input is focused
					if (devices.value.length > 0) {
						showSuggestions.value = true;
					}

				} else {
					Swal.fire('Error', response.data.message || 'Error fetching devices', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const fetchVehicleTypes = () => {

		get(routes.VehicleTypes, {}, false)
			.then((response) => {
				if (response.status === 200) {
					// console.log(response.data.data);
					vehicle_types.value = response.data.data;
				} else {
					Swal.fire('Error', response.data.message || 'Error fetching vehicle types', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const fetchRTOList = () => {
		get(routes.RTOList, {}, false)
			.then((response) => {
				if (response.status === 200) {
					// console.log(response.data.data);
					rto_list.value = response.data.data;
				} else {
					Swal.fire('Error', response.data.message || 'Error fetching RTO list', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const restrictMobileInput = (event) => {
		// Remove any non-digit characters and limit to 10 digits
		const value = event.target.value.replace(/\D/g, '').slice(0, 10);
		mobile.value = value;
	};

	const setFile = (e) => {
		rc_image.value = e.target.files[0];
	};

	const addWork = () => {
		// Set loading state
		let isSubmitting = true;
		errors.value = {};

		if ((product_id.value == 1 || product_id.value == '1') && (work_type.value == 1 || work_type.value == '1')) {
			if (!rc_image.value) {
				Swal.fire('Validation Error', 'RC Image is required for new work type', 'error');
				return;
			}
		}

		if (!rto_id.value) {
			Swal.fire('Validation Error', 'Please select an RTO', 'error');
			return;
		}

		const formData = new FormData();
		formData.append('product_id', product_id.value);
		formData.append('work_type', work_type.value);
		formData.append('customer_name', customer_name.value);
		formData.append('vehicle_no', vehicle_no.value);
		formData.append('vehicle_type', vehicle_type.value);
		formData.append('mobile', mobile.value);
		formData.append('date', date.value);
		// formData.append('location', location.value);
		// formData.append('latitude', latitude.value);
		// formData.append('longitude', longitude.value);
		formData.append('location', job.value.location);
		formData.append('latitude', job.value.latitude);
		formData.append('longitude', job.value.longitude);
		formData.append('is_enquiry', is_enquiry.value ? 1 : 2);
		if(rc_image.value){
			formData.append('rc_image', rc_image.value);
		}
		formData.append('technician_id', technician_id.value);
		formData.append('amount', amount.value);
		formData.append('imei', device_imei.value || '');
		formData.append('rto_id', rto_id.value);
		
		post(routes.AddWork, formData, false)
			.then((response) => {
				if (response.status === 200) {
					Swal.fire('', response.data.message || 'Work added successfully', 'success');
					router.push({ name: 'job_management'});
				} else {
					isSubmitting.value = false;
					Swal.fire('', response.data.message || 'Failed to add work', 'error');
				}
			})
			.catch((error) => {
				isSubmitting.value = false;
				if (error.response?.status === 422) {
					errors.value = error.response.data.message;
					// Show first validation error in Swal
					const firstError = Object.values(error.response.data.message)[0];
					if (firstError && firstError[0]) {
						Swal.fire('Validation Error', firstError[0], 'error');
					}
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});

	};

	const fetchDeviceWorkLogs = (url = null) => {
		// Don't fetch if no device_imei is provided
		if ((!device_imei.value || device_imei.value.trim() === '') && 
			(!vehicle_search.value || vehicle_search.value.trim() === '') && 
			(!vehicle_no.value || vehicle_no.value.trim() === '')) {
			device_work_logs.value = [];
			return;
		}

		let params = {
			limit: listing_length.value,
		};

		// For product_id = 1 (Select IMEI field), use vehicle_no (from AllDevices API)
		if (product_id.value == 1 || product_id.value == '1') {
			params.device_imei = null;
			params.vehicle_no = vehicle_no.value || '';
			params.mobile = null;
		} else {
			// For product_id != 1 (Search Vehicle No field), use vehicle_no (from old fetchDevices)
			params.device_imei = null;
			params.vehicle_no = vehicle_no.value || '';
			params.mobile = null;
		}

		const requestUrl = url ?? routes.DeviceWorkLogs;

		get(requestUrl, { params }, false)
			.then((response) => {
				if (response.status === 200) {
					// Handle different possible response structures
					let responseData = response.data.data;
					
					// If response.data.data.data exists, use that structure
					if (responseData && responseData.data) {
						device_work_logs.value = responseData.data || [];
						pagination.value = responseData.links || {};
						from.value = responseData.from;
						to.value = responseData.to;
						total.value = responseData.total;
					}
					// If response.data.data is directly an array
					else if (Array.isArray(responseData)) {
						device_work_logs.value = responseData;
						pagination.value = {};
						from.value = 1;
						to.value = responseData.length;
						total.value = responseData.length;
					}
					// If response.data.data is an object with different structure
					else if (responseData && typeof responseData === 'object') {
						device_work_logs.value = responseData.work_logs || responseData.logs || [];
						pagination.value = responseData.links || {};
						from.value = responseData.from || 1;
						to.value = responseData.to || device_work_logs.value.length;
						total.value = responseData.total || device_work_logs.value.length;
					}
					else {
						device_work_logs.value = [];
						pagination.value = {};
						from.value = 0;
						to.value = 0;
						total.value = 0;
					}

				} else {
					Swal.fire('', response.data.message || 'Error fetching data', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', error.response.data.message.limit?.[0] || error.response.data.message.device_id?.[0] || 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});
	};

	const setImei = (device) => {
		// Use the device's vehicle_no to fill the vehicle_no field
		vehicle_no.value = device.vehicle_no || '';
		
		// For product_id != 1 (non-GPS), use data directly from old fetchDevices
		if (product_id.value != 1 && product_id.value != '1') {
			vehicle_search.value = device.vehicle_no || '';
			device_imei.value = ''; // Keep IMEI empty for non-product-1
			mobile.value = device.mobile || '';
			device_id.value = device.id;
			// console.log('Non-GPS Device Data:', device);
		} else {
			// For product_id = 1 (GPS), use data directly from AllDevices API only
			device_imei.value = device.imei || '';
			vehicle_search.value = ''; // Keep vehicle_search empty for product-1
			mobile.value = device.mobile || '';
			device_id.value = device.id;
			// console.log('GPS Device Data from AllDevices:', device);
		}
		
		showSuggestions.value = false;
		fetchDeviceWorkLogs();
	};

	// Clear IMEI field and reset related data
	const clearImeiField = () => {
		device_imei.value = '';
		vehicle_no.value = '';
		mobile.value = '';
		device_id.value = '';
		device_work_logs.value = [];
		showSuggestions.value = false;
		devices.value = [];
	};

	// Clear vehicle search field and reset related data
	const clearVehicleSearchField = () => {
		vehicle_search.value = '';
		vehicle_no.value = '';
		mobile.value = '';
		device_id.value = '';
		device_work_logs.value = [];
		showSuggestions.value = false;
		devices.value = [];
	};

	// Watch for changes in vehicle_search to handle clearing
	const watchVehicleSearch = () => {
		if (!vehicle_search.value || vehicle_search.value.trim() === '') {
			clearVehicleSearchField();
		}
	};

	// Watch for changes in device_imei to handle clearing
	const watchDeviceImei = () => {
		if (!device_imei.value || device_imei.value.trim() === '') {
			clearImeiField();
		}
	};

	// Handle IMEI input with debounced search and clear functionality
	const handleImeiInput = () => {
		watchDeviceImei();
		if (device_imei.value && device_imei.value.trim() !== '') {
			// Use fetchAllDevices for GPS products (product_id == 1)
			if (product_id.value == 1 || product_id.value == '1') {
				fetchAllDevicesDebounced();
			} else {
				fetchDevicesDebounced();
			}
		}
	};

	// Handle vehicle search input with debounced search and clear functionality
	const handleVehicleSearchInput = () => {
		watchVehicleSearch();
		if (vehicle_search.value && vehicle_search.value.trim() !== '') {
			fetchDevicesDebounced();
		}
	};

	// Handle input blur with delay to allow for selection
	const handleInputBlur = () => {
		setTimeout(() => {
			showSuggestions.value = false;
		}, 200);
	};

	// Add click outside functionality
	const handleClickOutside = (event) => {
		const inputElement = event.target.closest('.form-control');
		const suggestionElement = event.target.closest('.list-group');
		
		if (!inputElement && !suggestionElement) {
			showSuggestions.value = false;
			showRtoSuggestions.value = false;
		}
	};

	// RTO dropdown handlers
	const handleRtoSearch = () => {
		if (rto_search.value && rto_search.value.trim() !== '') {
			showRtoSuggestions.value = true;
		} else {
			showRtoSuggestions.value = false;
			// Clear RTO ID if search is cleared
			if (!rto_search.value || rto_search.value.trim() === '') {
				rto_id.value = '';
			}
		}
	};

	const handleRtoInputBlur = () => {
		setTimeout(() => {
			showRtoSuggestions.value = false;
		}, 200);
	};

	const setRto = (rto) => {
		rto_search.value = `${rto.rto_code} - ${rto.rto_name}`;
		rto_id.value = rto.id;
		showRtoSuggestions.value = false;
	};

	// Clear RTO field
	const clearRtoField = () => {
		rto_search.value = '';
		rto_id.value = '';
		showRtoSuggestions.value = false;
	};



</script>

<style>
	html {
	scroll-behavior: smooth;
	}
</style>

